import React from 'react';
import PropTypes from 'prop-types';

import cn from 'utils/classnames';

import styles from './AppPoint.module.scss';

function AppPoint(props) {
  const { point, className } = props;

  return (
    <span className={cn(styles.Component, className)}>
      {point}
    </span>
  );
}

AppPoint.propTypes = {
  className: PropTypes.string,

  point: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

AppPoint.defaultProps = {
  className: '',

  point: 0,
};

export default React.memo(AppPoint);
